import baseSecretariat from 'moodleDir/procollege/lib/vue/default-block-root.vue';


export default {
  routes: [
    {
      path: '/',
      component:baseSecretariat,
      name:'baseSecretariat'
    },
  ]
};
